import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { getFacilityTypeLabel, type HaNTextRange } from "@lib/logic";
import type { FacilityResource } from "@lib/store";
import { ModalCellItemIcon } from "@molecules";

import { HaNSearchResultCell } from "./HaNSearchResultCell";

type FacilitySearchResultProps = {
  facility: FacilityResource;
  ranges: HaNTextRange[];
};

export const FacilitySearchResult = ({ facility, ranges }: FacilitySearchResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typeLabel = getFacilityTypeLabel(facility.data.facilityType, t);

  const details = [typeLabel !== facility.name && typeLabel, facility.floorName].filter(Boolean).join(", ");

  return (
    <HaNSearchResultCell
      icon={
        <ModalCellItemIcon
          className="flex-none"
          backgroundColor={theme.card.beige500.background}
          icon="toilet"
          iconUrl={facility.data.facilityType.lightIconUrl}
        />
      }
      name={facility.name}
      ranges={ranges}
      details={details}
    />
  );
};
